import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ThemeColor, defaultThemeColor, applyTheme } from "@/libs/theme";

type Theme = "light" | "dark";

interface ThemeState {
  theme: Theme;
  themeColor: ThemeColor;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
  setThemeColor: (themeColor: ThemeColor) => void;
  applyCurrentTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: "light",
      themeColor: defaultThemeColor,
      toggleTheme: () =>
        set((state) => ({ theme: state.theme === "light" ? "dark" : "light" })),
      setTheme: (theme) => set({ theme }),
      setThemeColor: (themeColor) => set({ themeColor }),
      applyCurrentTheme: () => {
        const { theme, themeColor } = get();
        applyTheme(themeColor, theme);
      },
    }),
    {
      name: "theme-storage",
      onRehydrateStorage: () => (state) => {
        // Apply theme after rehydration
        if (state) {
          state.applyCurrentTheme();
        }
      },
    }
  )
);
